import { V1QuestionnaireResource } from "@generated";
import { ManageSurvey } from "../types";
import { getFormattedDate } from "@utils/helperFunctions";

const formatManageSurveys = (data) => {
  const formattedQuestionnaires: ManageSurvey[] = [];
  if (data.data && data.data.length > 0) {
    [...data.data]
      .reverse()
      .map((questionnaire: V1QuestionnaireResource, i: number) => {
        formattedQuestionnaires.push({
          id: questionnaire.id ? String(questionnaire.id) : "",
          checked: false,
          attributes: {
            name: questionnaire.attributes?.name || "",
            status: questionnaire.attributes?.published ? "Published" : "Draft",
            createdOn: questionnaire.attributes?.["created-at"]
              ? getFormattedDate(
                  new Date(questionnaire.attributes["created-at"])
                )
              : "",
            tags: questionnaire.attributes?.["tag-list"]
              ? questionnaire.attributes["tag-list"]
              : [],
          },
        });
      });
  }
  return {
    data: formattedQuestionnaires,
    meta: { ...data?.meta, "record-count": formattedQuestionnaires.length },
    included: data.included,
  };
};

export default formatManageSurveys;
